import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Subject, takeUntil } from 'rxjs';
import { DeleteMembershipPlanModel } from 'src/app/admin-panel/models/business/delete-membership-plan.model';
import { MembershipPlanService } from 'src/app/admin-panel/services/business/membership-plan.service';

@Component({
  selector: 'app-delete-membership-plans',
  templateUrl: './delete-membership-plans.component.html',
  styleUrls: ['./delete-membership-plans.component.scss']
})
export class DeleteMembershipPlansComponent implements OnInit {

 //#region Fields
 public membershipPlanId: string;
 public deleteMembershipPlanModel : DeleteMembershipPlanModel = new DeleteMembershipPlanModel();
 public spinner :boolean=false;
 public unsubscribe: Subject<void> = new Subject<void>();
 //#endregion
 //#region Constructor
 constructor(
   private ref: DynamicDialogRef,
   private config: DynamicDialogConfig,
   public membershipPlanService: MembershipPlanService,
   public messageService: MessageService
 ) {
   if (this.config.data != undefined && this.config.data.id) {
    this.deleteMembershipPlanModel.productId = this.config.data.id
   }
 }

 ngOnInit(): void {
 }
 //#endregion
 //#region Public Methods
 deleteMembershipPlan() {
  this.spinner = true
  this.membershipPlanService.deleteproduct(this.deleteMembershipPlanModel)
  .pipe(takeUntil(this.unsubscribe))
  .subscribe({
    next: (response) => {  
      this.spinner = false      
      this.ref.close(true)
    },
    error: errorResponse => {
      this.spinner = false 
    }
  });
}
cancel() {
  this.ref.close(false)
}
 //#endregion
 //#Private Methods
 //#endregion

}
